import axios from 'axios';
import { useState, useEffect } from 'react';
import { getColumnLength } from './utils';
import useConfirm from '../../../components/common/useConfirm';
import { ModuleDataHandler } from './handleReportCalc';
import { useQuery } from '../../../hooks/UseQuery';

const useGetData = (
  annual_date: string | null | undefined,
  created_date: string | null | undefined
) => {
  const [moduleData, setModuleData] = useState<any>([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [customerforAuto, setCustomerforAuto] = useState<any>();
  const [isSync, setIsSync] = useState(false);
  const [prodArea, setProdArea] = useState();
  const [DialogSync, confirmSync] = useConfirm(
    'Sync New Parts',
    'Are you sure you want to Sync ? Make sure to save any changes before syncing!'
  );

  useEffect(() => {
    axios
      .get('/api/customerRoutes/')
      .then((res) => {
        setCustomer(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);

  const handelSync = async () => {
    const ans = await confirmSync();
    if (!ans) return;
    const ColumnLength = getColumnLength(annual_date || '');
    axios
      .get(
        `/api/salePlanningRoute/syncPart/${annual_date}/${ColumnLength}/${created_date}?customer_id=${customerforAuto?._id}&production_area=${prodArea}`
      )
      .then((res) => {
        window.alert(
          'successfully sync dont forget to save the document after sync'
        );
        const data = res.data.result;
        const dataHandler = new ModuleDataHandler(data);
        data.forEach((_: any, index: number) => {
          dataHandler.syncSaleRate(index);
        });
        setModuleData(data);
      })
      .catch((err) => {
        console.log(err);
        alert(err.response.data.msg);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    const cancelTokenSource = axios.CancelToken.source();
    const handleApi = async () => {
      axios
        .get(
          `/api/salePlanningRoute/${annual_date}?customer_id=${customerforAuto?._id}&production_area=${prodArea}`
        )
        .then((response) => {
          response.data.success && setModuleData(response.data.result);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
          alert(`${err.response.data.msg} TRY SYNCING!`);
          setModuleData([]);
          setError(err);
        });
    };

    handleApi();

    return () => {
      cancelTokenSource.cancel('Request canceled');
    };
  }, [customerforAuto, prodArea]);

  return {
    moduleData,
    customer,
    setIsSync,
    isLoading,
    handelSync,
    DialogSync,
    error,
    setModuleData,
    customerforAuto,
    setCustomerforAuto,
    prodArea,
    setProdArea,
  };
};

export default useGetData;
